<template>
  <section class="ren-decoration-cp ren-decoration-cp-scenic-ticket-info">
    <strong class="ren-decoration-cp-scenic-ticket-info__price">
      {{ scenicYuan(ticket.priceCents) }}
    </strong>
    <div class="ren-decoration-cp-scenic-ticket-info__name">{{ ticket.name }}</div>

    <div
      v-if="showTags || showSales"
      class="ren-decoration-cp-scenic-ticket-info__chips">
      <i v-if="showTags" v-for="(tag, index) in ticket.tags" :key="`${tag}-${index}`">{{ tag }}</i>
      <span v-if="showSales" class="ren-decoration-cp-scenic-ticket-info__sales">
        月销量 {{ ticket.sales }}
      </span>
    </div>

    <div v-if="showService" class="ren-decoration-cp-scenic-ticket-info__menu">
      <span><b>服务</b>{{ serviceSummary }}</span>
      <em v-if="ticket.hasServiceDesc">›</em>
    </div>
    <div v-if="showNotice" class="ren-decoration-cp-scenic-ticket-info__menu">
      <span><b>须知</b>{{ noticeSummary }}</span>
      <em v-if="ticket.hasNoticeDesc">›</em>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, stringValue } from '../../../previews/preview-helpers'
import { SAMPLE_TICKET, scenicYuan } from '../../scenic-preview-data'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const ticket = computed(() => ({
  ...SAMPLE_TICKET,
  ...(stringValue(props.component.props?.name) ? { name: stringValue(props.component.props?.name) } : {})
}))
const showTags = computed(() => booleanValue(props.component.props?.showTags, true))
const showSales = computed(() => booleanValue(props.component.props?.showSales, true))
const showService = computed(() => booleanValue(props.component.props?.showService, true))
const showNotice = computed(() => booleanValue(props.component.props?.showNotice, true))
const serviceSummary = computed(() => ticket.value.service.join(' · '))
const noticeSummary = computed(() => ticket.value.notice.join(' · '))
</script>

<style scoped>
.ren-decoration-cp-scenic-ticket-info {
  display: grid;
  gap: 8px;
  padding: 12px;
  background: var(--ren-theme-card);
}
.ren-decoration-cp-scenic-ticket-info__price {
  color: var(--ren-theme-accent);
  font-size: 18px;
}
.ren-decoration-cp-scenic-ticket-info__name {
  color: var(--ren-theme-text);
  font-size: 14px;
  font-weight: 600;
}
.ren-decoration-cp-scenic-ticket-info__chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 11px;
}
.ren-decoration-cp-scenic-ticket-info__chips i {
  font-style: normal;
  padding: 2px 7px;
  border: 1px solid var(--ren-theme-border);
  border-radius: 4px;
  color: var(--ren-theme-muted);
}
.ren-decoration-cp-scenic-ticket-info__sales {
  color: var(--ren-theme-muted);
}
.ren-decoration-cp-scenic-ticket-info__menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: var(--ren-theme-muted);
  font-size: 12px;
  line-height: 1.6;
}
.ren-decoration-cp-scenic-ticket-info__menu b {
  margin-right: 10px;
  color: var(--ren-theme-text);
  font-weight: 500;
}
.ren-decoration-cp-scenic-ticket-info__menu span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ren-decoration-cp-scenic-ticket-info__menu em {
  flex-shrink: 0;
  font-style: normal;
  color: var(--ren-theme-border);
  font-size: 14px;
}
</style>
